import type {
  HeaderDetailsApiResponse,
  UpdateAvatarApiRequest,
  DashboardDetailsApiResponse,
  UpdateUserStateApiRequest
} from "@ts/interfaces/student/api/studentAccountApiInterface";
import { get, post } from "./httpClient";
import type { ApiResponseInterface } from "@ts/interfaces/ApiResponseInterface";
import type { StudentsFamilyUsedAvatarsInterface } from "@/ts/interfaces/student/studentAccountInterface";

export const getHeaderDetails = async (): Promise<HeaderDetailsApiResponse> => {
  return await get<HeaderDetailsApiResponse>("/user/header-details");
};

export const getStudentsFamilyUsedAvatars =
  async (): Promise<StudentsFamilyUsedAvatarsInterface> => {
    return await get("/user/family-selected-avatars");
  };

export const updateAvatar = async ({
  content
}: UpdateAvatarApiRequest): Promise<ApiResponseInterface<void>> => {
  return await post("/core/webhook", {
    event_type: "avatar_changed",
    content
  });
};

export const getDashboardDetails = async (
  gradeCode: number
): Promise<DashboardDetailsApiResponse> => {
  return await get<DashboardDetailsApiResponse>(
    `/user/dashboard-details/${gradeCode}`
  );
};

export const updateUserState = async (
  data: UpdateUserStateApiRequest
): Promise<ApiResponseInterface<void>> => {
  return await post("/user/state", data);
};

export const markNotificationAsRead = async (
  notificationId: number
): Promise<ApiResponseInterface<void>> => {
  return await post(`/user/notifications/${notificationId}/mark-as-read`);
};

export const studentAccountApi = {
  getHeaderDetails,
  getStudentsFamilyUsedAvatars,
  updateAvatar,
  getDashboardDetails,
  updateUserState,
  markNotificationAsRead
};
